import { gql } from '@apollo/client';
import { AssetFragment } from '../../graphql/fragments/Asset';

export const ProductCardProductFragment = gql`
  fragment ProductCardProductFragment on Product {
    id
    title
    url
    itemCount
    categories
    collections
    demographics {
      gender
      age
    }
    attributes {
      activities
      hasCompression
      hasPocket
      hasGripper
      sockHeight
      sockWeight
      endUse
      neckCollarType
      cut
      sleeveLength
      material
      uwCoverage
      waistRise
    }
    colors {
      id
      title
      swatch {
        id
        file {
          url
        }
      }
    }
    externalSystems {
      shopify
    }
    sizes {
      id
      title
      options {
        id
        value
        guidance
      }
    }
    variants {
      id
      price {
        currency
        percentOff
        basePrice
        discountPrice
      }
      images {
        id
        title
        image {
          ...AssetFragment
        }
      }
      available
      categories
      color {
        id
        swatch {
          id
        }
      }
      externalSystems {
        shopify
      }
      sizes {
        id
        title
        value
      }
      itemCount
      sku
      components {
        endUse
        primaryMaterial
        lifestyle
      }
    }
  }
  ${AssetFragment}
`;

export const ProductCardFragment = gql`
  fragment ProductCardFragment on ProductCard {
    ... on ProductCard {
      color
      badge
      product {
        ...ProductCardProductFragment
      }
    }
  }
  ${ProductCardProductFragment}
`;

export default {};
